import React, { useContext } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
// import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Toolbar from '@mui/material/Toolbar';
// import HomeIcon from '@mui/icons-material/Home';
import { useHistory } from 'react-router-dom';
import Logo from 'components/Helpers/Logo';
import { uiContext } from 'contexts/UIContext';
import Switch from '@mui/material/Switch';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CloseIcon from '@mui/icons-material/Close';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import NavigationExploreMenuDrawer from 'components/Navigation/NavigationExploreMenuDrawer';
import Stack from '@mui/material/Stack';
import NavigationItemList from './NavigationItemList';
import IconButton from '@mui/material/IconButton';
import { IS_DEV } from 'environment';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    toolbar: {
      // Same height as main AppBar->Toolbar
      minHeight: 60,
      padding: theme.spacing(0, 2),
      display: 'flex',
      justifyContent: 'space-between',
    },
    list: {
      width: 388, //12px for scroll bar
      [theme.breakpoints.down('md')]: {
        width: '100vw',
        paddingLeft: theme.spacing(1.5),
      },
    },
  }),
);

interface NavListItemProps {
  text: string;
  onClick?: () => void;
}

const NavItems = [
  { title: 'Check Balance', path: '/redeem' },
  { title: 'spacer' },
  { title: 'About Us', path: '/page/about-us' },
  { title: 'Contact Us', path: '/page/contact-us' },
  { title: 'spacer' },
  { title: 'Privacy Policy', path: '/page/privacy-policy' },
  { title: 'Terms of Service', path: '/page/terms-of-service' },
];

export default function TemporaryDrawer({ open = false, onClose = () => {} }) {
  const classes = useStyles();
  const history = useHistory();
  const { debugMode, setDebugMode, cdnDisabled, setCDNDisabled, showExploreDrawer, setShowExploreDrawer } = useContext(uiContext);

  const NavListItem = (props: NavListItemProps) => {
    return (
      <Stack direction="row" alignItems="center" sx={{ px: 2 }} onClick={props.onClick}>
        <ListItemText primary={props.text} sx={{ cursor: 'pointer' }} />
        <IconButton edge="end" color="primary" aria-label="close" size="large">
          <ArrowForwardIcon />
        </IconButton>
      </Stack>
    );
  };

  const onHideDrawer = () => {
    setShowExploreDrawer(false);
    onClose();
  };

  const onBack = () => {
    setShowExploreDrawer(false);
  };

  return (
    <>
      <Drawer open={open} onClose={onClose} anchor="right">
        <div className={classes.list} role="presentation" onKeyDown={onClose}>
          <Toolbar className={classes.toolbar}>
            <Logo />
            <IconButton edge="end" color="primary" onClick={onClose} aria-label="close" size="large">
              <CloseIcon sx={{ fontSize: 30 }} />
            </IconButton>
          </Toolbar>
          <List>
            <NavListItem text="Explore Gift Cards" onClick={() => setShowExploreDrawer(true)} />
            <NavListItem
              text="Redeem"
              onClick={() => {
                history.push('/redeem');
                onClose();
              }}
            />
            <NavListItem
              text="Card.Gift Business"
              onClick={() => {
                history.push('/landing/corporate');
                onClose();
              }}
            />
            <Divider sx={{ mt: 3, mb: 2, mx: 2 }} />
            <Stack sx={{ px: 2, mb: 2 }}>
              <NavigationItemList items={NavItems} onClose={onClose} />
            </Stack>
            {(IS_DEV || debugMode) && (
              <>
                <ListItem>
                  <ListItemText primary="👻 Debug Mode" />
                  <Switch color="secondary" edge="end" onChange={(ev) => setDebugMode(!debugMode)} checked={debugMode} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="🥶 CDN Enabled?" />
                  <Switch color="secondary" edge="end" onChange={(ev) => setCDNDisabled(!cdnDisabled)} checked={cdnDisabled} />
                </ListItem>
              </>
            )}
          </List>
        </div>
      </Drawer>
      <NavigationExploreMenuDrawer status={showExploreDrawer} onClose={onHideDrawer} onBack={onBack} />
    </>
  );
}
